export interface ITicketMessageResponse {
    data: {
        id: number;
        ticketId: number;
        createdDateTime: Date;
        visibility: boolean;
        message: string;
    }
}